import React, { useEffect, useState } from 'react'
import { PATHS } from 'Config/Routing/paths'
import { withRouter } from 'react-router-dom'
import InternalFiles from '../../Containers/Campaigns/Page/InternalFiles'
import { CAMPAIGN_SUBTYPES_ENUM } from '../../shared/constants'
import { getNextLink } from '../../Utils/Link'

const InternalFilesRouterRaw = props => {
  const [shouldRedirectToNextEnv, setShouldRedirectToNextEnv] = useState(null)
  const [loading, setLoading] = useState(true)

  const verifyRedirectionNeeded = async () => {
    try {
      const shouldRedirect =
        props.campaign &&
        (props.campaign.subtype === CAMPAIGN_SUBTYPES_ENUM.EDDM ||
          props.campaign.subtype === CAMPAIGN_SUBTYPES_ENUM.ADM)
      setShouldRedirectToNextEnv(shouldRedirect)
    } catch (e) {
      setShouldRedirectToNextEnv(false)
    }

    setLoading(false)
  }

  useEffect(() => {
    verifyRedirectionNeeded()
  }, [props.campaign])

  useEffect(() => {
    if (shouldRedirectToNextEnv) {
      const campaignId = props.match.params.campaignId
      const path = `/dashboard/campaigns/${campaignId}${
        PATHS.campaign.internalFiles
      }`
      window.location.href = getNextLink(path)
    }
  }, [shouldRedirectToNextEnv])

  if (loading || shouldRedirectToNextEnv) {
    return null
  }

  return <InternalFiles {...props} />
}

export const InternalFilesRouter = withRouter(props => {
  return <InternalFilesRouterRaw {...props} />
})
